import { Link } from 'react-router-dom';

type ActionControlProps = {
  label: string;
  plain: string;
  href?: string;
  to?: string;
  className?: string;
};

export function ActionControl({ label, plain, href, to, className = '' }: ActionControlProps) {
  const controlClass = `tab-control ${className}`;
  const control = to ? (
    <Link to={to} className={controlClass}>
      [ {label} ]
    </Link>
  ) : (
    <a href={href} target="_blank" rel="noreferrer" className={controlClass}>
      [ {label} ]
    </a>
  );

  return (
    <div className="flex flex-col items-start gap-1">
      {control}
      <span className="dim text-sm normal-case tracking-normal">{plain}</span>
    </div>
  );
}
